// rpath?: 是对路由的一种补偿，在cdn发布后，理论上已经不存在RootPath内容
//         如果在路由上配置了RootPath，就会导致路由错误，所以使用rpath来补偿
const routers = [
  {
    path: "",
    name: "ipath",
    meta: { hidden: false },
    component: () => import("@/views/ipath.vue"),
  },
  {
    path: ":rpath?/demo",
    name: "demo",
    meta: { hidden: false },
    component: () => import("@/views/demo.vue"),
    //   children: [
    //     {
    //       path: 'demo',
    //       name: 'demo',
    //       meta: { hidden: true },
    //       component: () => import('@/views/demo.vue'),
    //     }
    //   ]
  },
];
export default routers;
